"use client";

import './Button.scss';

import React from 'react';

/**
 * Footer displayed in the App component.
 * @constructor
 */
export default function Button({ enabled = true, loading = false, children, onClick = null, href = null, className = null, target="_blank" }) {
    if (href) {
        return <a className={className ? "button " + className : "button"} target={target} href={href}>
            {!loading ? children : <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>}
        </a>
    }
    return (
        <button className={className ? "button " + className : "button"} onClick={(e) => {
            e.preventDefault();
            (onClick || (() => { }))();
        }} disabled={!enabled || loading}>
            {!loading ? children : <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>}
        </button>
    );
}
